if (!customElements.get("video-reels")) {
  customElements.define(
    "video-reels",
    class VideoReels extends HTMLElement {
      constructor() {
        super();
        this.activeClass = "active";
      }

      connectedCallback() {
        this.swiper = this.querySelector(".wt-slider__container");
               this.isTargetSection = true;

        this.mobileQuery = window.matchMedia("(max-width: 899px)");
        this.sectionVisible = false;
        this.videosLoaded = !this.querySelector("[data-lazy-src]");

        this.handleResize = () => {
          if (!this.mobileQuery.matches) {
            this.loadVideos();
            if (this.swiper?.swiper) {
              this.handleSlideChange(this.swiper.swiper);
            }
          }
        };

        if (this.isTargetSection) {
          this.mobileQuery.addEventListener("change", this.handleResize);

          if (!this.mobileQuery.matches) {
            this.loadVideos();
          } else if ("IntersectionObserver" in window) {
            this.loadObserver = new IntersectionObserver(
              (entries) => {
                if (entries.some((entry) => entry.isIntersecting)) {
                  this.loadVideos();
                  this.loadObserver.disconnect();

                  if (this.sectionVisible && this.swiper?.swiper) {
                    this.playVideoInActiveSlide(this.swiper.swiper);
                  }
                }
              },
              { rootMargin: "200px 0px", threshold: 0 },
            );
            this.loadObserver.observe(this);
          } else {
            this.loadVideos();
          }
        }

        this.checkInterval = setInterval(
          () => this.checkSwiperInitialization(),
          500,
        );
      }

      loadVideos() {
        this.querySelectorAll("video").forEach((video) => {
          const sources = video.querySelectorAll("[data-lazy-src]");
          const hasVideoSource = video.hasAttribute("data-lazy-src");

          if (!hasVideoSource && !sources.length) return;

          if (hasVideoSource) {
            video.setAttribute("src", video.dataset.lazySrc);
            video.removeAttribute("data-lazy-src");
          }

          sources.forEach((source) => {
            source.setAttribute("src", source.dataset.lazySrc);
            source.removeAttribute("data-lazy-src");
          });

          if (!this.mobileQuery.matches) {
            video.removeAttribute("preload");
          }

          video.load();
        });

        this.videosLoaded = true;
      }

      safePlay(video) {
        const result = video.play();
        if (result && typeof result.catch === "function") {
          result.catch(() => {});
        }
      }

      updateAllVideosSound(swiper) {
        const soundOn = swiper.el.dataset.sound === "on";

        swiper.slides.forEach((slide) => {
          const video = slide.querySelector("video");
          if (video) video.muted = !soundOn;
        });
      }

      observeSection() {
        if (!("IntersectionObserver" in window)) {
          this.sectionVisible = true;
          return;
        }

        this.sectionObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.sectionVisible = entry.isIntersecting;

              if (this.isTargetSection) {
                if (entry.isIntersecting) {
                  this.loadVideos();

                  if (this.swiper?.swiper) {
                    this.playVideoInActiveSlide(this.swiper.swiper);
                  }
                } else {
                  this.pasueAllVideos();
                }
              } else {
                const video = document.querySelector(
                  ".swiper-slide-active video",
                );

                if (video) {
                  if (entry.isIntersecting) {
                    this.safePlay(video);
                  } else {
                    video.pause();
                  }
                }
              }
            });
          },
          { root: null, rootMargin: "0px", threshold: 0.1 },
        );

        this.sectionObserver.observe(this);
      }

      handleSoundToggle(swiper) {
        swiper.slides.forEach((slide) => {
          const button = slide.querySelector(".wt-video__sound-toggle");
          const video = slide.querySelector("video");
          if (!button || !video) return;

          button.addEventListener("click", () => {
            video.muted = !video.muted;
            swiper.el.dataset.sound = video.muted ? "off" : "on";
            this.updateAllVideosSound(swiper);
          });
        });
      }

      pasueAllVideos() {
        this.querySelectorAll("video").forEach((video) => video.pause());
      }

      playVideoInActiveSlide(swiper) {
        if (
          this.isTargetSection &&
          this.mobileQuery.matches &&
          (!this.videosLoaded || !this.sectionVisible)
        ) {
          return;
        }

        const video = this.findActiveSlide(swiper)?.querySelector("video");

        if (video) {
          video.muted = swiper.el.dataset.sound !== "on";
          this.safePlay(video);
        }
      }

      findActiveSlide(swiper) {
        return swiper.slides[swiper.activeIndex];
      }

      toggleActiveClass(swiper) {
        const activeSlide = this.findActiveSlide(swiper);

        swiper.slides.forEach((slide) => {
          slide.classList.toggle(this.activeClass, slide === activeSlide);
        });
      }

      handleSlideChange(swiper) {
        this.pasueAllVideos();
        this.toggleActiveClass(swiper);
        this.playVideoInActiveSlide(swiper);
      }

      checkSwiperInitialization() {
        if (
          !this.swiper?.swiper ||
          !this.swiper.classList.contains("swiper-initialized")
        ) {
          return;
        }

        const swiper = this.swiper.swiper;
        this.slideChangeHandler = (instance) =>
          this.handleSlideChange(instance);

        swiper.on("slideChange", this.slideChangeHandler);
        this.handleSlideChange(swiper);
        this.handleSoundToggle(swiper);
        this.observeSection();
        clearInterval(this.checkInterval);
      }

      disconnectedCallback() {
        clearInterval(this.checkInterval);
        this.loadObserver?.disconnect();
        this.sectionObserver?.disconnect();

        if (this.handleResize) {
          this.mobileQuery?.removeEventListener("change", this.handleResize);
        }

        if (this.slideChangeHandler && this.swiper?.swiper) {
          this.swiper.swiper.off("slideChange", this.slideChangeHandler);
        }
      }
    },
  );
}